module.exports = __webpack_public_path__ + "img/logo.05fc81ae.png";